<section class="panel" [class.open]="vm.open">
  <section class="header">
    <button class="body bold flex gap-8" (click)="open.set(!open())">
      <span class="link-text"> {{ vm.open ? 'Hide' : 'Show' }} contact hours </span>

      <i class="fa-light" [class.fa-chevron-up]="vm.open" [class.fa-chevron-down]="!vm.open"></i>
    </button>
  </section>

  <section class="content" [appAnimateOpen]="vm.open">
    <section class="flex mt-12 gap-8 full-width">
      @for (day of vm.contactHours; track day.day) {
        <section class="flex times">
          <p class="body">
            {{ day.day }}
          </p>

          @if (day.isClosed) {
            <p class="body">Closed</p>
          } @else {
            <p class="body">{{ day.open | timeFormat }} - {{ day.close | timeFormat }}</p>
          }
        </section>
      }
    </section>
  </section>
</section>
